export interface IRecipientView {
    recpId: number,
    centerId: number,
    registrationDate: string,
    recipientIsDeleted: boolean,
    sendComplianceEmails: boolean,
    patientIsTargetedChainEnd: boolean,
    chainNumber: number,
    cluster: number,
    position: number,
    status: number
}